import { createFileRoute, redirect } from '@tanstack/react-router'
import UsersPage from '@/views/users-page'
import { hasOrgPermission } from '@/user/user'
import { users } from '@/api/api'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/users/',
)({
  component: UsersPage,
  beforeLoad: async ({ context, params }) => {
    // Get current user data
    const user = await context.queryClient.ensureQueryData(users.me())

    // Check if user has permission to list organization members
    if (
      !hasOrgPermission(
        user,
        params.organizationId,
        'sensorkit_meta.list_organization_members',
      )
    ) {
      throw redirect({
        to: '/organization/$organizationId',
        params: { organizationId: params.organizationId },
      })
    }
  },
})
